import React, { useEffect, useState, useRef } from "react";
import ongoingVendorService from "../../services/ongoing-vendor";
import { toast } from "react-toastify";
import { handleErrors } from "../../utils/errorHandler";
import { Modal, Button, Form } from "react-bootstrap";
import Flatpickr from "react-flatpickr";
import "flatpickr/dist/themes/material_green.css";

const VendorOngoing = () => {
  const [bookings, setBookings] = useState([]);
  const [showModal, setShowModal] = useState(false);
  const [showModalComplete, setShowModalComplete] = useState(false);
  const [selectedBookingGuid, setSelectedBookingGuid] = useState(null);
  const [markasComplete, setMarkasComplete] = useState(null);
  const [requoteAmount, setRequoteAmount] = useState("");
  const [showRequoteModal, setShowRequoteModal] = useState(false);
  const [fromDate, setFromDate] = useState("");
  const [toDate, setToDate] = useState("");
  const [searchInput, setSearchInput] = useState("");
  const [searchTerm, setSearchTerm] = useState("");
  const searchInputRef = useRef(null);

  const renderBookStatusBadge = (bookStatus) => {
    let badgeClass = "outlined-badge badge-purple";
    switch (bookStatus) {
      case "Success":
        badgeClass = "outlined-badge badge-green";
        break;
      case "Initiated":
        badgeClass = "outlined-badge badge-gray";
        break;
      case "Vendor Assigned":
        badgeClass = "outlined-badge badge-blue";
        break;
      case "Vendor Re-Assigned":
        badgeClass = "outlined-badge badge-yellow";
        break;
      case "Vendor Re-Quoted":
        badgeClass = "outlined-badge badge-purple";
        break;
      case "Re-Quote Accepted":
        badgeClass = "outlined-badge badge-blue";
        break;
      case "Cancelled":
        badgeClass = "outlined-badge badge-orange";
        break;
      case "Completed":
        badgeClass = "outlined-badge badge-indigo";
        break;
      default:
        badgeClass = "outlined-badge badge-gray";
    }
    return <span className={`badge  ${badgeClass}`}>{bookStatus}</span>;
  };

  const fetchBookings = async () => {
    try {
      const formData = {
        pageSize: 100,
        pageNo: 1,
        sParam: searchTerm,
        bookStatus: "",
        fromDate,
        toDate,
      };
      const response = await ongoingVendorService.ongoingServicesBooking(
        formData
      );
      if (response.data.isSuccess) {
        setBookings(response.data.result);
      }
    } catch (error) {
      let errorMessage = handleErrors(error);
      if (error.response && error.response.status === 500) {
        errorMessage = error.response.data.message;
      }
      toast.error(errorMessage);
    }
  };
  useEffect(() => {
    fetchBookings();
  }, [fromDate, toDate]);
  const handleCancelBooking = async () => {
    try {
      await ongoingVendorService.cancelServicesBooking(selectedBookingGuid);
      toast.success("Booking cancelled successfully");
      fetchBookings();
      setShowModal(false);
    } catch (error) {
      let errorMessage = handleErrors(error);
      if (error.response && error.response.status === 500) {
        errorMessage = error.response.data.message;
      }
      toast.error(errorMessage);
      setShowModal(false);
    }
  };

  const handleamarkasComplete = async () => {
    try {
      await ongoingVendorService.markAsCompleteService(markasComplete);
      toast.success("Mark As Complete  successfully");
      fetchBookings();
      setShowModalComplete(false);
    } catch (error) {
      let errorMessage = handleErrors(error);
      if (error.response && error.response.status === 500) {
        errorMessage = error.response.data.message;
      }
      toast.error(errorMessage);
      setShowModalComplete(false);
    }
  };

  const confirmComplete = (bookingGuid) => {
    setMarkasComplete(bookingGuid);
    setShowModalComplete(true);
  };

  const formatDate = (dateString) => {
    const date = new Date(dateString);
    return date.toLocaleDateString("en-GB", {
      day: "2-digit",
      month: "short",
      year: "numeric",
    });
  };

  const handleRequoteSubmit = async () => {
    try {
      await ongoingVendorService.requoteService(
        selectedBookingGuid,
        requoteAmount
      );
      toast.success("Re-quote submitted successfully");
      setShowRequoteModal(false);
      setRequoteAmount("");
      fetchBookings();
    } catch (error) {
      toast.error(handleErrors(error));
      setShowRequoteModal(false);
    }
  };
  const handleSearchClick = () => {
    setSearchTerm(searchInput);
  };
  useEffect(() => {
    if (searchTerm !== "") {
      fetchBookings();
    }
  }, [searchTerm]);
  return (
    <div>
      <div className="">
        <h3>Ongoing Bookings Details</h3>
      </div>
      <div className="filter-row">
        <div className="mt-3">
          <Flatpickr
            id="fromDate"
            className="date-filters"
            placeholder="Select From Date"
            value={fromDate}
            onChange={([date]) => setFromDate(date)}
            options={{
              dateFormat: "Y-m-d",
              monthSelectorType: "static",
            }}
          />
        </div>
        <div className="mt-3">
          <Flatpickr
            id="toDate"
            className="date-filters"
            placeholder="Select To Date"
            value={toDate}
            onChange={([date]) => setToDate(date)}
            options={{
              dateFormat: "Y-m-d",
              monthSelectorType: "static",
            }}
          />
        </div>
        <div className="mt-3">
          <div className="search-input">
            <input
              type="text"
              id="search"
              className="date-filters"
              value={searchInput}
              onChange={(e) => setSearchInput(e.target.value)}
              placeholder="Search...."
              ref={searchInputRef}
            />
          </div>
        </div>
        <div className=" mt-3">
          <div className="">
            <button
              className="date-filters btn orange-btn text-white"
              onClick={handleSearchClick}
            >
              Search
            </button>
          </div>
        </div>
      </div>
      <div className="row">
        <div className="col-md-10 gap-4">
          {bookings.length === 0 ? (
            <div className="text-center mt-4">
              <h6>No Ongoing bookings available.</h6>
            </div>
          ) : (
            bookings.map((booking, index) => (
              <div
                key={booking.id}
                className="ongoning-details-card rounded-lg p-4 border mt-3"
              >
                <div className="ongoing-status flex justify-between items-center mb-2">
                  <h6 className="booking-details">
                    {booking.bookingNo} | {formatDate(booking.bookedOn)}
                  </h6>
                  <div>{renderBookStatusBadge(booking.bookStatus)}</div>
                </div>
                <div className="mb-1">
                  <h5>{booking.serviceName}</h5>
                </div>
                <div className="user-details mb-1">
                  Customer - {booking.userName || "N/A"} | {booking.contactNo}
                </div>

                <div className="quoted-button gap-2">
                  {(booking.bookStatus === "Vendor Assigned" ||
                    booking.bookStatus === "Vendor Re-Assigned") && (
                    <>
                      {/* <button
                        className="badge bg-success"
                        onClick={() => {
                          setSelectedBookingGuid(booking.bookingGuid);
                          setShowRequoteModal(true);
                        }}
                      >
                        Re-Quote
                      </button> */}
                      <button
                        className="badge bg-danger"
                        onClick={() => confirmComplete(booking.bookingGuid)}
                      >
                        Mark As Completed
                      </button>
                    </>
                  )}
                  {booking.bookStatus === "Success" && (
                    <button
                      className="badge text-bg-success text-white"
                      // onClick={() => confirmCancel(booking.bookingGuid)}
                    >
                      Accept
                    </button>
                  )}
                </div>
              </div>
            ))
          )}
        </div>
      </div>
      <Modal
        show={showModalComplete}
        onHide={() => setShowModalComplete(false)}
        style={{ maxWidth: "90%", margin: "0 auto" }}
      >
        <Modal.Header closeButton>
          <Modal.Title>Confirmation</Modal.Title>
        </Modal.Header>
        <Modal.Body>Are you sure you want to Mark As Completed?</Modal.Body>
        <Modal.Footer>
          <Button
            variant="secondary"
            className="badge bg-secondary"
            onClick={() => setShowModalComplete(false)}
          >
            No
          </Button>
          <Button
            variant="danger"
            className="badge bg-danger"
            onClick={handleamarkasComplete}
          >
            Yes
          </Button>
        </Modal.Footer>
      </Modal>
      {/* Bootstrap Modal for Confirmation */}
      <Modal
        show={showModal}
        onHide={() => setShowModal(false)}
        style={{ maxWidth: "90%", margin: "0 auto" }}
      >
        <Modal.Header closeButton>
          <Modal.Title>Confirmation</Modal.Title>
        </Modal.Header>
        <Modal.Body>Are you sure you want to cancel this booking?</Modal.Body>
        <Modal.Footer>
          <Button
            variant="secondary"
            className="badge bg-secondary"
            onClick={() => setShowModal(false)}
          >
            No
          </Button>
          <Button
            variant="danger"
            className="badge bg-danger"
            onClick={handleCancelBooking}
          >
            Yes, Cancel
          </Button>
        </Modal.Footer>
      </Modal>
      <Modal show={showRequoteModal} onHide={() => setShowRequoteModal(false)}>
        <Modal.Header closeButton>
          <Modal.Title>Submit Re-Quote</Modal.Title>
        </Modal.Header>
        <Modal.Body>
          <Form>
            <Form.Group>
              <Form.Label>Requote Amount</Form.Label>
              <Form.Control
                type="number"
                value={requoteAmount}
                onChange={(e) => setRequoteAmount(e.target.value)}
              />
            </Form.Group>
          </Form>
        </Modal.Body>
        <Modal.Footer>
          <Button
            variant="secondary"
            className="badge bg-secondary"
            onClick={() => setShowRequoteModal(false)}
          >
            Cancel
          </Button>
          <Button
            variant="primary"
            className="badge bg-primary"
            onClick={handleRequoteSubmit}
          >
            Submit
          </Button>
        </Modal.Footer>
      </Modal>
    </div>
  );
};

export default VendorOngoing;
